<template>
  <generic-modal
    size="small"
    :title="$t('password change')"
    icon="key"
    image="/images/icons/password.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <h4 class="ui dividing header">{{ $t("confirm password change") }}</h4>

      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("current password") }}</label>
            <input type="password" name="current" v-model="current_password" />
          </div>
          <div class="field">
            <label for>{{ $t("new password") }}</label>
            <input type="password" name="new" v-model="new_password" />
          </div>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, success_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import sha1 from "js-sha1";

export default {
  name: "StudentChangePasswordModal",
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    user_in: Object,
  },
  data() {
    return {
      current_password: "",
      new_password: "",
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/student_portal/user/do-change-password", {
            c: sha1(vm.current_password),
            n: sha1(vm.new_password),
            u: vm.user_in.uuid,
          })
            .then(() => {
              success_toast(vm.$t("password updated"));
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      // this.$emit("destroy");
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        current: ["empty"],
        new: ["empty"],
      },
    });
  },
  created() {},
  watch: {
    products() {
      // this.init_product_dropdown();
      this.init_provider_dropdown();
      this.init_product_search();
    },
    use_same_provider() {
      let vm = this;
      if (vm.use_same_provider) {
        let trgtProvider = undefined;
        vm.products.map((p, i) => {
          if (i == 0) {
            trgtProvider = p.provider;
          } else {
            if (trgtProvider) p.provider = trgtProvider;
          }
        });
      }
    },
  },
  updated: function() {},
};
</script>
